const time = {
  "周": "週",
  "天": "日",
  "小时": "時間",
  "分钟": "分",
  "刚刚": "たった今",
  "前": "前",
  "昨天": "昨日",
  "星期一": "月曜日",
  "星期二": "火曜日",
  "星期三": "水曜日",
  "星期四": "木曜日",
  "星期五": "金曜日",
  "星期六": "土曜日",
  "星期日": "日曜日",
}

export default time;